import 'slick-carousel/slick/slick'

export default class RecentEventsSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-recent-events-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                slidesToScroll: 1,
                appendDots: $('.js-re-slider-dots'),
                prevArrow: $('.js-re-slider-previous'),
                nextArrow: $('.js-re-slider-next'),

                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            arrows: false,
                            dots: true,
                        }
                    },
                ]
            });
        }

    }

};

new RecentEventsSlider();